import { useCallback, useContext, useMemo } from 'react';
import { unpack_validation } from 'z3k-parser/validation/types';
import { useBox } from 'shared/hooks/utils';
import { z3k_key_namespace } from 'console/device-settings/z3k/utils/namespaces';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { useLocation } from 'react-router';
export function useUnpackEditingProps(parent_props, field) {
    const parentValueBoxed = useBox(parent_props.value);
    const value = parent_props.value[field];
    const onChange = useCallback((new_value) => parent_props.onChange({ ...parentValueBoxed.current, [field]: new_value }), [parent_props.onChange]);
    const validation_result = unpack_validation(parent_props.validation_result, field);
    const validation_warnings_result = unpack_validation(parent_props.validation_warnings_result, field);
    return useMemo(() => ({
        value,
        onChange,
        validation_result,
        validation_warnings_result,
    }), [value, onChange, validation_result, validation_warnings_result]);
}
export function useEditingProps(id, name, field) {
    const editorContext = useContext(Z3KSettingsEditor);
    const boxed_config = useBox(editorContext.config);
    const self = z3k_key_namespace[name];
    //always have item! trust me!
    const item = self.get.byId(editorContext.config, id);
    const value = item[field];
    const onChange = useCallback((new_value) => editorContext.replace_config(self.get.applySetterById(boxed_config.current, id, { [field]: new_value })), [id, field]);
    const validation_result = unpack_validation(self.get.validationResultById(editorContext.config, editorContext.validation_result, id), field);
    const validation_warnings_result = unpack_validation(self.get.validationResultById(editorContext.config, editorContext.validation_warnings_result, id), field);
    return useMemo(() => ({
        value,
        onChange,
        validation_result,
        validation_warnings_result,
    }), [value, onChange, validation_result, validation_warnings_result]);
}
export function useEditItem(id, name) {
    const editorContext = useContext(Z3KSettingsEditor);
    const boxed_config = useBox(editorContext.config);
    const self = z3k_key_namespace[name];
    const onChange = useCallback((setter) => editorContext.replace_config(
    //@ts-ignore
    self.get.applySetterById(boxed_config.current, id, setter)), [id]);
    return onChange;
}
export function useGetZ3kObject(name) {
    const item_id = useLocation().state?.item_id;
    const _id = Number(item_id ?? -1);
    const editorContext = useContext(Z3KSettingsEditor);
    const self = z3k_key_namespace[name];
    //always have item! trust me!
    const item = self.get.byId(editorContext.config, _id);
    if (!item) {
        console.log('try get incorrect element! from z3k config');
        const first_item = self.get.all(editorContext.config)?.[0];
        if (first_item) {
            return first_item;
        }
        console.error('no one elementes of type', self);
        return first_item;
    }
    return item;
}
